import React from 'react';
import PropTypes from 'prop-types';

import ManagementLayout from 'components/layouts/ManagementLayout';

import UsersContent from './components/UsersContent';

/**
 * User Management landing page (PD-4063): the paginated, sortable users table.
 *
 * Filters and search follow in later phases, and the mockup's TEAMS column waits
 * on PD-4213.
 *
 * This component holds no state on purpose — see UsersContent for why the shell
 * and the page body are split.
 */
function Users({ appLinks, currentPath, currentUser, footer }) {
  return (
    <ManagementLayout
      appLinks={appLinks}
      currentPath={currentPath}
      currentUser={currentUser}
      footer={footer}
    >
      <UsersContent />
    </ManagementLayout>
  );
}

Users.propTypes = {
  appLinks: ManagementLayout.propTypes.appLinks,
  currentPath: PropTypes.string,
  currentUser: ManagementLayout.propTypes.currentUser,
  footer: ManagementLayout.propTypes.footer,
};

Users.defaultProps = {
  appLinks: [],
  currentPath: undefined,
  currentUser: undefined,
  footer: undefined,
};

export default Users;
